import { render, staticRenderFns } from "./oldDetailDialog.vue?vue&type=template&id=36d25b1c&scoped=true&"
import script from "./oldDetailDialog.vue?vue&type=script&lang=js&"
export * from "./oldDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./oldDetailDialog.vue?vue&type=style&index=0&id=36d25b1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d25b1c",
  null
  
)

export default component.exports